import { MultiSelectComponentProps } from "@eworkit/iris";
import React, { FC, useEffect, useState } from "react";

import { fetchConsultantProfileList, IConsultantProfile } from "@/data/consultant-profiles";
import { IFilterComponentProps } from "@/infrastructure/Filter";
import { ConsultantMultiTypeahead } from "@/views/components/Typeaheads/Consultant";

interface IManagersFilterProps
  extends Omit<IFilterComponentProps<Array<IConsultantProfile>>, "value">,
    Omit<MultiSelectComponentProps<IConsultantProfile>, "name" | "onChange" | "value"> {
  searchParams: any;
  profileIds?: number[];
}

export const ApplicationCandidatesFilter: FC<IManagersFilterProps> = ({
  name,
  profileIds,
  onChange,
  searchParams,
  ...rest
}) => {
  const [value, setValue] = useState<IConsultantProfile[]>([]);

  useEffect(() => {
    if (profileIds && value.length == 0) {
      initializeURLData();
    }
  }, [profileIds]);

  const initializeURLData = async () => {
    setValue(await fetchConsultantProfileList({ profileIds, ...searchParams }).then(response => response.content));
  };

  const onChangeHandler = (name: string, cb: (v: { [name: string]: any }) => void) => {
    return (value: IConsultantProfile[]) => {
      setValue(value);
      cb({ [name]: value.map(v => (v.id ? v.id : v)) });
    };
  };
  const handleChange = onChangeHandler(name, onChange);

  return (
    <ConsultantMultiTypeahead
      size="md"
      value={value}
      onChange={handleChange}
      companyId={searchParams.companyId}
      {...rest}
    />
  );
};
